module.exports = __webpack_public_path__ + "static/media/MP.7c2f1ed7.png";